import React, { useState } from 'react'
import RitualScreen from '../../../screens/app/Profile/RitualScreen'
import StartupModal from './StartupModal'
import { useSession } from '../../../hooks/useSession'

function RitualModal() {
  const [showRituals, setShowRituals] = useState(true)
  const { user } = useSession()

  if (!user || user.rituals.length > 0) {
    return null
  }

  return (
    <StartupModal modalVisible={showRituals} setModalVisible={setShowRituals}>
      <RitualScreen
        rituals={user.rituals}
        navigate={false}
        onClose={() => {
          setShowRituals(false)
        }}
      />
    </StartupModal>
  )
}

export default RitualModal
